import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { finalize, Subject, takeUntil } from 'rxjs';
import { Season } from '../../models/season.model';
import { SeasonSelectorService } from './season-selector.service';

@Component({
  standalone: false,
  selector: 'app-season-selector',
  templateUrl: './season-selector.component.html',
  styleUrls: ['./season-selector.component.scss'],
})
export class SeasonSelectorComponent implements OnInit, OnDestroy {
  @Input() partner: string;
  @Input() organisationId: string;

  seasons: Season[];
  selectedSeason: Season;
  isLoading = false;

  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    private seasonSelectorService: SeasonSelectorService
  ) { }

  ngOnInit() {
    this.getSeasons();
  }

  async ngOnDestroy() {
    this.seasonSelectorService.season = null;
    this.destroy$.next();
    this.destroy$.complete();
  }

  getSeasons() {
    this.isLoading = true;

    this.seasonSelectorService
      .getSeasons(this.organisationId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.isLoading = false)
      )
      .subscribe(
        async res => {
          this.seasons = res.data;

          if (this.seasons?.length) {
            this.selectedSeason = this.seasons[0];
            this.seasonSelectorService.publishSelectedSeason(this.selectedSeason);
          }
        }
      )
  }

  emitSeason(ev) {
    this.selectedSeason = this.seasons[ev.detail.value];
    this.seasonSelectorService.publishSelectedSeason(this.selectedSeason);
  }

}
